(async() => {
while(!window.hasOwnProperty("jQuery")||!jQuery.fn.validate||!jQuery.fn.mask) {
    await new Promise(resolve => setTimeout(resolve, 100));
}


'use strict';
var $ = jQuery;

var _calc = {

  calcCount: 0,
  nlShown: false,
  klaviyoFormId: 'TqqqJc',

  init: function () {
    _calc.setCalc();
  },

showNewsletter: function(){
    if(_calc.nlShown) return;
    _calc.nlShown = true;
    // Klaviyo popup disabled - uncomment to re-enable
     if(window.openLockedKlaviyoForm){
       window.openLockedKlaviyoForm(_calc.klaviyoFormId);
     } else if(window._klOnsite){
       window._klOnsite.push(['openForm', _calc.klaviyoFormId]);
     }
  },

  runCalc: function(els){
    var $msg = els.form.find('.msg'),
    s = els.scale,
    temp = els.temp.val(),
    dew = els.dew.val(),
    rh = els.rh.val();
    $msg.text('');
    console.log(s.is(':checked'));if ((temp != "") && (s.is(':checked'))) {
      temp = parseFloat((temp-32.0000000001)/1.8);}
    if ((dew != "") && (s.is(':checked'))) {
      dew = parseFloat((dew-32.0000000001)/1.8);}

    if ((temp == "" ) && (dew != "") && (rh != "")){
      var gamma = (17.27*eval(dew))/(237.7+eval(dew));
      var temp_numer = 237.7*(gamma-Math.log(rh/100));
      var temp_denom = 17.27+Math.log(rh/100)-gamma;
      var dummy_temp = temp_numer/temp_denom;
      if (s == "Fahrenheit") {
        dummy_temp = (dummy_temp*1.8)+32.;
      }
      els.temp.val(dummy_temp.toFixed(2));
      _calc.calcCount++;
    }
    else if ((dew == "") && (rh != "") && (temp != "")){
      var dew_numer = 237.7*(Math.log(rh/100)+((17.27*eval(temp))/(eval(temp)+237.7)));var dew_denom = 17.27-Math.log(rh/100)-((17.27*eval(temp))/(eval(temp)+237.7));
      var dummy_dew = dew_numer/dew_denom;
      if (s == "Fahrenheit") {
        dummy_dew = (dummy_dew*1.8)+32.;
      }
      els.dew.val(dummy_dew.toFixed(2));
      _calc.calcCount++;
    }
    else if ((rh == "") && (temp != "") && (dew != "")){
      var rh_numer = 100.0*Math.exp((17.27*eval(dew))/(eval(dew)+237.7));
      var rh_denom = Math.exp((17.27*eval(temp))/(eval(temp)+237.7));
      els.rh.val((rh_numer/rh_denom).toFixed(2));
      _calc.calcCount++;
    }
    else if ((rh != "") && (temp != "") && (dew != "")){
      $msg.html("<div>Please leave one of the fields blank.</div>");
    } else{
      $msg.html("<div>Please fill out any two fields.</div>");
    }

    if(_calc.calcCount >= 3){
      _calc.showNewsletter();
    }

  },
  setCalc: function(){
    var els = {
      form: $("#tempCalc"),
      scale : $('#calcScale'),
      temp: $('#calcTemp'),
      dew: $('#calcDew'),
      rh : $('#calcRH')
    };
    $.validator.addMethod("digitsonly", function(value, element) {
      return this.optional(element) || /^[0-9.]+$/i.test(value);
    }, "Digits only");
    els.temp.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
    els.dew.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
    els.rh.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});

    els.form.validate({
      rules: {
        "calcTemp": {
          digitsonly: true
        },
        "calcDew": {
          digitsonly: true
        },
        "calcRH": {
          digitsonly: true
        }
      },
      submitHandler: function(form) {
        form.preventDefault;
        _calc.runCalc(els);
        return false;
      }
    });
  }
};

$(document).ready(_calc.init);

})();